var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showBanner,
          expression: "showBanner",
        },
      ],
      staticClass: "alert",
      style: { backgroundColor: _vm.$themePalette.yellow.v_100 },
    },
    [
      _c("div", { staticStyle: { display: "flex" } }, [
        _c(
          "div",
          [
            _c("KIcon", {
              staticClass: "icon",
              attrs: { icon: "warning", color: _vm.$themePalette.amber.v_a400 },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "error-message" }, [
          _vm.py27Deprecated
            ? _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.coreString("pythonSupportWillBeDropped")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm.currentUserOnIE11
            ? _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.coreString("currentDeviceUsingIE11")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm.userDevicesUsingIE11
            ? _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.coreString("userDevicesUsingIE11")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm.currentUserOnIE11 || _vm.userDevicesUsingIE11
            ? _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.coreString("browserSupportWillBeDroppedIE11")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }